import {Injectable} from "@angular/core";
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {TemplateDTO} from "../model/template-dto.model";
import {TemplateCodeTypes} from "../../enum/template-code.enum";
import {PageResponseDTO} from "../../model/page-response.model";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class TemplateService {

  private baseUrl: string = environment.host + "/templates";

  constructor(private http: HttpClient) {
  }

  getTemplateByCode(code: TemplateCodeTypes) {
    return this.http.get<TemplateDTO>(this.baseUrl + "/" + code);
  }

  getTemplatesByParent(id: number) {
    return this.http.get<TemplateDTO[]>(this.baseUrl + "/children/" + id).pipe(
      map((templates)=> templates.map( item => new TemplateDTO(item)))
    );
  }

  getTemplateById(id: number) {
    return this.http.get<TemplateDTO>(this.baseUrl + "/detail/" + id);
  }

  searchTemplate(code: TemplateCodeTypes) {
    return this.http.get<PageResponseDTO<TemplateDTO>>(this.baseUrl + "/search", {
      params: {code}
    });
  }

}
